import React, { useMemo, useState } from "react";
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { System, Template } from "types";
import { CustomButton } from "core";
import { BoxHeadlineContainer } from "layout/Container/BoxHeadlineContainer";
import utils from "utils";

type SystemStatisticsProps = {
  templateList: Template[];
  systemList: System[];
};

export const SystemStatistics: React.FC<SystemStatisticsProps> = ({
  templateList,
  systemList,
}) => {
  const [colors, setColors] = useState<string[]>(
    systemList.map(() => utils.colors.getRandomColor()),
  );

  const loadNewColors = () => {
    setColors(systemList.map(() => utils.colors.getRandomColor()));
  };

  const systemStatisticsData = useMemo(() => {
    const systemTemplates = systemList.map((system) => ({
      system,
      templates: templateList.filter(
        (template) => template.systemID === system.id,
      ),
    }));

    return systemTemplates.map((systemTemplate, index) => ({
      name: systemTemplate.system.name,
      menge: systemTemplate.templates.length,
      fill: colors[index],
    }));
  }, [systemList, templateList, colors]);

  console.log("systemStatisticsData: ", systemStatisticsData);

  return (
    <BoxHeadlineContainer
      boxTitle="System-Statistiken"
      marginTop={false}
      boxMenu={
        <CustomButton
          text="Neue Farben"
          onClick={() => loadNewColors()}
          size="small"
        />
      }
    >
      <ResponsiveContainer width="100%" height={300}>
        <BarChart height={300} data={systemStatisticsData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Bar dataKey="menge" />
        </BarChart>
      </ResponsiveContainer>
    </BoxHeadlineContainer>
  );
};
